import React from "react";

import classnames from "classnames";

const styles = {
    sm: "w-9 h-9 text-base",
    md: "w-10 h-10 text-lg",
    lg: "w-12 h-12 text-xl",
    gray: "bg-gray-100 text-gray-500",
    purple: "bg-tint text-brand",
    green: "bg-green-100 text-success",
    yellow: "bg-yellow-100 bg-opacity-70 text-yellow-600",
    destructive: "bg-tintActive text-destructive",
    none: "bg-none"
};
export function IconFrame({
    icon,
    size = "md",
    color = "gray" as "gray" | "yellow" | "purple" | "destructive" | "green",
    customColor = "",
    isCircle = false,
    className = "",
    onClick = () => {}
}) {
    return (
        <div
            className={classnames(
                "iconFrame",
                customColor ? customColor : color,
                isCircle && "isCircle",
                size,
                className
            )}
            onClick={onClick}
        >
            <i className={icon}></i>
        </div>
    );
}
